// extracted by mini-css-extract-plugin
export default {"dateBtn":"SwitchDate_dateBtn__QHyCH","active":"SwitchDate_active__Nm7Hk"};